import * as _ from "lodash";
import * as angular from "angular";
import { Team } from "../../models/team.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";

let GroupAssignAutocompleteComponent = {
    selector: "vcGroupAssignAutocomplete",
    templateUrl:
        "/angular/components/group/group-assign-autocomplete.component.html",
    bindings: {
        selectedUsers: "=?",
        selectedTeams: "=?",
        invites: "=?",
        label: "=?",
        noLabel: "=?",
        autoFocus: "=?",
        clearButton: "=?",
        required: "=?",
        isDisabled: "=?",
        showEmail: "=?",
        permissions: "=?",
        placeholder: "@?",
        hideUsers: "=?",
        noCreate: "=?",
    },

    controller: class UnifiedAutocompleteController {
        // * bindings for typescript compiler *
        public selectedUsers?: any[];
        public selectedTeams?: any[];
        public invites?: any;
        public label?: string;
        public noLabel?: boolean;
        public autoFocus?: boolean;
        public clearButton?: boolean;
        public required?: boolean;
        public isDisabled?: boolean;
        public inProgress?: boolean;
        public showEmail?: boolean;
        public permissions?: any;
        public placeholder?: string;
        public hideUsers?: boolean;
        public noCreate?: boolean;
        // ************************************

        private $scope: any;
        private userDataProvider: UserDataProvider;
        private $http: any;
        private $q: any;
        private __env: any;
        private modelsUtils: any;
        private dialog: DialogUtils;

        public search: string = "";
        public usersSearchPromise: any;
        public teamsSearchPromise: any;
        public previousSearch: any;
        public combinedResults: any[] = [];
        public matchedUsers: any;
        public matchedTeams: any;

        public teams: any;
        public users: any;

        constructor(
            $scope: any,
            UserDataProvider: UserDataProvider,
            $http: any,
            $q: any,
            __env: any,
            ModelsUtils: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.userDataProvider = UserDataProvider;
            this.$http = $http;
            this.$q = $q;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.label = this.label || "Search users and teams";
            this.noLabel = this.noLabel || false;
            this.autoFocus = this.autoFocus || false;
            this.clearButton = this.clearButton || false;
            this.showEmail = this.showEmail || false;
            this.required = this.required || false;
            this.isDisabled = this.isDisabled || false;
            this.selectedUsers = this.selectedUsers || [];
            this.selectedTeams = this.selectedTeams || [];
            this.noCreate = this.noCreate || false;
            this.hideUsers = angular.isUndefined(this.hideUsers)
                ? false
                : this.hideUsers;

            if (this.selectedUsers || this.selectedTeams) {
                this.$scope.$watch(
                    () => ({
                        users: this.selectedUsers,
                        teams: this.selectedTeams,
                    }),
                    (newValue, oldValue) => {
                        if (
                            oldValue &&
                            (newValue.users < oldValue.users ||
                                newValue.teams < oldValue.teams)
                        ) {
                            this.searchAll(this.search, true);
                        }
                    },
                    true
                );
            }
        }

        itemText(item: any): string {
            if (item._type === "user") {
                if (item.uid) {
                    let text: string = item.ufname + " " + item.ulname;
                    if (item.uemail) {
                        text = text + " - " + item.uemail;
                    }
                    if (item.uphonenumber) {
                        text =
                            text +
                            " - (+" +
                            item.ucountrycode +
                            ") " +
                            item.uphonenumber;
                    }
                    return text;
                } else {
                    return "Unassigned";
                }
            } else if (item._type === "team") {
                return item.tname || "";
            }
            return "";
        }

        selected(item: any): void {
            if (!item || item._type === "section-header") {
                this.search = "";
                return;
            }
            if (item._type === "user") {
                if (this.selectedUsers) {
                    this.selectedUsers.push({
                        uid: item.uid ?? null,
                        uemail: item.uemail ?? null,
                        ucountrycode: item.ucountrycode ?? null,
                        uphonenumber: item.uphonenumber ?? null,
                        ufname: item.ufname ?? null,
                        ulname: item.ulname ?? null,
                        images: { small: item.images?.small ?? null },
                        campaigninviteemail: item.campaigninviteemail ?? null,
                        campaigninvitephonenumber:
                            item.campaigninvitephonenumber ?? null,
                        campaigninvitecountrycode:
                            item.campaigninvitecountrycode ?? null,
                        campaigninviteid: item.campaigninviteid ?? null,
                    });
                }
            } else if (item._type === "team") {
                if (this.selectedTeams) {
                    this.selectedTeams.push(_.cloneDeep(item));
                }
            }

            if (this.search != "") {
                this.search = "";
                // this.searchAll(this.search, true);
            }
        }

        filterResults(): any[] {
            let teams = this.filterMatchedTeams(this.teams);
            let users = this.filterMatchedUsers(this.users);
            let combinedResults = [];

            // Add Teams section if there are teams
            if (teams.length > 0) {
                combinedResults.push({
                    _type: "section-header",
                    _section: "Teams",
                });
                teams.forEach((team) => {
                    combinedResults.push({
                        ...team,
                        _type: "team",
                    });
                });
            }

            // Add Users section if there are users
            if (users.length > 0) {
                combinedResults.push({
                    _type: "section-header",
                    _section: "Users",
                });
                users.forEach((user) => {
                    combinedResults.push({
                        ...user,
                        _type: "user",
                    });
                });
            }

            return combinedResults;
        }

        searchAll(query: any, refresh: boolean = false): Promise<any> {
            const searchQuery = query || "";

            // 1. Check Cache
            if (searchQuery === this.previousSearch && !refresh) {
                return this.$q.resolve(this.filterResults());
            }

            const deferred = this.$q.defer();

            if (!refresh) {
                this.previousSearch = searchQuery;
            } else {
                this.previousSearch = null;
            }
            const userPromise = this.searchUsers(searchQuery, true);
            const teamPromise = this.searchTeams(searchQuery, true);
            this.$q
                .all([userPromise, teamPromise])
                .then((results) => {
                    this.users = results[0] || [];
                    this.teams = results[1] || [];
                    this.combinedResults = this.filterResults();
                    deferred.resolve(this.filterResults());
                })
                .catch((error) => {
                    console.error("Search error:", error); // Debug log
                    deferred.resolve([]);
                });

            return deferred.promise;
        }

        searchUsers(query: any, refresh: boolean = false): Promise<any[]> {
            const deferred = this.$q.defer();
            if (this.usersSearchPromise)
                this.usersSearchPromise.resolve("user cancelled");
            this.usersSearchPromise = this.$q.defer();
            let email_regex =
                /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
            let sendQuery = query.replace(email_regex, "");
            sendQuery = sendQuery.replace("-", "");

            this.$http
                .post(
                    this.__env.apiUrl() + "/campaign/user/alldash",
                    {
                        filters: {
                            search: sendQuery,
                            needsEmail: false,
                            limit: this.userDataProvider.loadSize,
                            permission: this.permissions,
                        },
                    },
                    {
                        timeout: this.usersSearchPromise.promise,
                    }
                )
                .then((response: any) => {
                    if (!response || !response.data || !response.data.data) {
                        deferred.resolve([]);
                        return;
                    }

                    let filteredUsers = this.filterMatchedUsers(
                        response.data.data
                    );

                    deferred.resolve(filteredUsers);
                })
                .catch(() => {
                    deferred.resolve([]);
                });

            return deferred.promise;
        }

        searchTeams(query: any, refresh: boolean = false): Promise<any[]> {
            const deferred = this.$q.defer();
            if (this.teamsSearchPromise)
                this.teamsSearchPromise.resolve("user cancelled");
            this.teamsSearchPromise = this.$q.defer();
            let filters = {
                search: query,
                needsCount: false,
                limit: 10,
                selectedTeams: this.selectedTeams
                    ? this.selectedTeams.map((team: Team) => team.tid)
                    : [],
            };

            this.$http({
                url: "/v2/team/all",
                method: "GET",
                params: { filters: filters },
                timeout: this.teamsSearchPromise.promise,
            })
                .then((response: any) => {
                    if (!response || !response.data || !response.data.data) {
                        deferred.resolve([]);
                        return;
                    }

                    let teams = [];
                    for (let i = 0; i < response.data.data.length; i++) {
                        teams.push(
                            this.modelsUtils.team(response.data.data[i])
                        );
                    }

                    deferred.resolve(this.filterMatchedTeams(teams));
                })
                .catch(() => {
                    deferred.resolve([]);
                });

            return deferred.promise;
        }

        filterMatchedUsers(data: any): any[] {
            let matchedUsers = [];

            angular.forEach(data, (user: any) => {
                let found = false;
                if (this.selectedUsers) {
                    angular.forEach(this.selectedUsers, (selectedUser: any) => {
                        if (selectedUser.uid === user.uid) {
                            found = true;
                        }
                    });
                }
                if (!found) {
                    matchedUsers.push(this.modelsUtils.user(user));
                }
            });

            // Add invites
            angular.forEach(this.invites || [], (invite: any) => {
                if (
                    this.search === "" ||
                    (invite.campaigninviteemail &&
                        invite.campaigninviteemail.includes(this.search))
                ) {
                    let found = false;
                    if (this.selectedUsers) {
                        angular.forEach(this.selectedUsers, (selectedUser) => {
                            if (
                                (invite.campaigninviteemail &&
                                    selectedUser.campaigninviteemail ===
                                        invite.campaigninviteemail) ||
                                (invite.campaigninvitephonenumber &&
                                    invite.campaigninvitecountrycode &&
                                    invite.campaigninvitephonenumber ===
                                        selectedUser.campaigninvitephonenumber)
                            ) {
                                found = true;
                            }
                        });
                    }
                    angular.forEach(matchedUsers, (matchedUser: any) => {
                        if (
                            invite.campaigninviteid ===
                            matchedUser.campaigninviteid
                        ) {
                            found = true;
                        }
                    });
                    if (!found) {
                        matchedUsers.push(invite);
                    }
                }
            });
            this.matchedUsers = matchedUsers;
            return matchedUsers;
        }

        filterMatchedTeams(teams: any[]): any[] {
            let matchedTeams = teams.filter((team) => {
                if (!this.selectedTeams) return true;
                return !this.selectedTeams.some(
                    (selectedTeam) => selectedTeam.tid === team.tid
                );
            });
            this.matchedUsers = matchedTeams;
            return matchedTeams;
        }
    },
};

angular
    .module("group")
    .component(
        GroupAssignAutocompleteComponent.selector,
        GroupAssignAutocompleteComponent
    );
